import { CSSProperties } from 'react';
import { Location } from 'react-router-dom';

interface QueryParams {
  highlightId: string;
  searchParam: string;
}

class SearchService {
  public searchParam = 'searchParam';
  public highlightParam = 'highlightId';

  /** Get query param(s) keys and values as `QueryParams`. */
  public useQueryParams(search: string) {
    const queryValues: QueryParams = { highlightId: '', searchParam: '' };
    const queryResults = Object.fromEntries(new URLSearchParams(search));

    Object.entries(queryResults).forEach(([key, value]) => {
      if (Object.keys(queryValues).find((k) => k === key)) {
        queryValues[key as keyof QueryParams] = value;
      }
    });
    return queryValues;
  }

  /** Remove query param(s) from the URL. */
  public removeQueryParam(navigate: Function, location: Location) {
    const searchParams = new URLSearchParams(location.search);
    // Remove all query params from the URL.
    const queryResults = Object.fromEntries(
      new URLSearchParams(location.search)
    );
    Object.keys(queryResults).forEach((key) => {
      searchParams.delete(key);
    });

    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true
    });
  }

  public highlightItem(primaryColor: string): CSSProperties {
    return {
      outline: `2px solid ${primaryColor}`
    };
  }

  public scrollItem(highlightId: string) {
    const element = document.getElementById(`${highlightId}`);
    if (element) {
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 50);
    }
  }
}

export default new SearchService();
